import {
  append,
  applySpec,
  assoc,
  clone,
  compose,
  find,
  ifElse,
  indexBy,
  isEmpty,
  isNil,
  map,
  prop,
  propEq,
  propOr,
  reduce
} from "ramda";
import {defaultOr, normalize, nothing, slugIs} from "../../lib/utils";

const DEFAULT_CURRENCY = {"id": "1", "name": "Рубль", "country_iso": "RU", "symbol": "₽", "code": "RUB", "rate": 1};

export default {
  /**
   * Вычисление выбранной линии
   * Возвращает объект линии
   * @returns {object}
   */
  currency(state) {
    return defaultOr(
      DEFAULT_CURRENCY,
      find(propEq('code', state.currencyCode), state.currencies)
    );
  },
  currencyCode(state, getters) {
    return getters.currency ? getters.currency.code : 'RUB';
  },
  currencyRate(state, getters) {
    return getters.currency ? getters.currency.rate : 1;
  },

  currencySelect(state) {
    return ifElse(
      isNil, nothing,
      map(applySpec({
        text: prop('name'),
        value: prop('code')
      }))
    )(state.currencies)
  },
  hideChange(state, getters) {
    return ['UZS', 'KZT'].includes(getters.currencyCode)
  },
  lineSelectOptions(state) {
    return map(applySpec({
      text: prop('label'),
      value: prop('slug')
    }), state.lines);
  },


  /**
   * Вычисление выбранной линии
   * Возвращает объект линии
   * @returns {object}
   */
  line(state) {
    return ifElse(
      isNil, nothing, // Проверка на отсутствие выбранной линии
      find(slugIs(state.currentLine))
    )(state.lines)
  },

  /**
   * Вычисляет выбранный рецепт
   * Возвращает объект рецерта
   * @returns {object}
   */
  recipe(store) {
    return ifElse(
      isEmpty, nothing,
      compose(
        (recipe) => assoc('index', indexBy(prop('name'), recipe.ingredients), recipe),
        (recipe) => assoc('ingredients', normalize(recipe.ingredients), recipe),
        clone,
        find(propEq('name', store.currentRecipe)),
      )
    )(store.recipes);
  },

  result(state, getters) {
    const energyTariff = state.source.energyTariff;
    const rent = state.source.rent;
    const tariff = state.source.tariff;
    const productionVolume = state.period * state.capability;

    const ingredients = compose(
      append({
        ...tariff,
        purchase: {
          multiplier: 1,
          measure: tariff.measure
        },
        consumption: getters.line.employers,
        amount: null,
        priceOfSq: tariff.price.value,
        sum: tariff.price.value * productionVolume,
      }),
      append({
        ...rent,
        purchase: {
          multiplier: 1,
          measure: rent.measure
        },
        consumption: rent.amount.value,
        priceOfSq: (rent.price.value * rent.amount.value) / (state.capability * 30),
        sum: (rent.price.value * rent.amount.value) / (state.capability * 30) * state.period,
      }),
      append({
        ...energyTariff,
        purchase: {
          multiplier: 1,
          measure: energyTariff.measure
        },
        consumption: energyTariff.amount.value * productionVolume,
        priceOfSq: energyTariff.price.value * energyTariff.amount.value,
        sum: energyTariff.price.value * (energyTariff.amount.value * productionVolume),
      }),
      map((ing) => {
        return {
          ...ing,
          consumption: ing.amount.value * productionVolume,
          priceOfSq: ing.price.value * ing.amount.value,
          sum: ing.price.value * (ing.amount.value * productionVolume)
        }
      }),
      propOr([], 'ingredients')
    )(state.source);

    const [sum, costOfSq] = reduce(([sum, costOfSq], ing) => {
      return [sum + ing.sum, costOfSq + ing.priceOfSq];
    }, [0, 0], ingredients);

    const priceOfSq = state.source.price.price.value;
    const profitBySq = priceOfSq - costOfSq;
    const profitInPeriod = profitBySq * productionVolume;

    return {
      ingredients,
      costOfSq,
      sum,
      currency: getters.currency,
      priceOfSq,
      profitBySq,
      profitInPeriod,
      productionVolume,
      capability: state.capability,
      period: state.period,
      line: getters.line,
    }
  }
}
